export default __webpack_public_path__ + "static/media/scroll.88eca209.png";